import { labelValue } from './pathwayConfig';

export function normalizeCourseTitle(value = '') {
  return String(value || '').trim().toLowerCase();
}

export function rankSuggestions(baseList, priorityList = []) {
  const preferred = priorityList.filter((item) => baseList.includes(item));
  const remainder = baseList.filter((item) => !preferred.includes(item));
  return [...preferred, ...remainder];
}

export function getPreferredPathwayTheme(profile) {
  const emphasisMap = {
    balanced: 'balanced',
    leadership: 'leadership',
    strategy: 'strategy',
    finance: 'finance',
    digital: 'digital'
  };

  if (emphasisMap[profile.preferredEmphasis]) {
    return emphasisMap[profile.preferredEmphasis];
  }

  const objectiveMap = {
    'lead-change': 'leadership',
    'strategic-growth': 'strategy',
    'finance-fluency': 'finance',
    'digital-transformation': 'digital',
    'broader-leadership': 'balanced'
  };

  return objectiveMap[profile.primaryObjective] || 'balanced';
}

export function cleanFitLabel(label = '') {
  return label.replace(/\s*\([+-]?\d+\)\s*$/, '').trim();
}

export function buildFitTalkingPoint(driver, profile, recommendation) {
  const label = cleanFitLabel(driver).toLowerCase();
  const objective = labelValue('primaryObjective', profile.primaryObjective);
  const challenge = labelValue('currentChallenge', profile.currentChallenge);
  const outcome = labelValue('desiredOutcome', profile.desiredOutcome);
  const emphasis = labelValue('preferredEmphasis', profile.preferredEmphasis);
  const format = labelValue('formatPreference', profile.formatPreference);
  const timing = labelValue('completionWindow', profile.completionWindow);

  if (label.includes('primary objective') && objective) {
    return `Links directly to the stated objective: ${objective}.`;
  }
  if (label.includes('challenge') && challenge) {
    return `Addresses the current business challenge: ${challenge}.`;
  }
  if (label.includes('desired outcome') && outcome) {
    return `Supports the target outcome: ${outcome}.`;
  }
  if (label.includes('format') && format) {
    return `Matches the preferred delivery style: ${format}.`;
  }
  if ((label.includes('short duration') || label.includes('extended window')) && timing) {
    return `Fits the expected completion timeline: ${timing}.`;
  }
  if (label.includes('leadership')) {
    return `Useful leadership conversation starter: position this as building influence, change leadership, and senior stakeholder confidence.`;
  }
  if (label.includes('strategy')) {
    return `Strong strategy talking point: position this around sharper judgement, execution discipline, and value creation.`;
  }
  if (label.includes('finance')) {
    return `Strong finance talking point: position this around commercial confidence, financial fluency, and board-level decision-making.`;
  }
  if (label.includes('digital')) {
    return `Good transformation angle: position this around digital priorities, innovation, and technology-enabled change.`;
  }
  if (label.includes('senior') || label.includes('experience')) {
    return `Audience fit looks credible for the participant's seniority and management experience.`;
  }
  if (emphasis) {
    return `Reinforces the preferred pathway emphasis: ${emphasis}.`;
  }
  return `Use this as a supporting proof point for why ${recommendation.title} belongs in the sequence.`;
}

export function buildWatchoutTalkingPoint(watchout) {
  const label = cleanFitLabel(watchout).toLowerCase();

  if (label.includes('format')) {
    return 'Check delivery mode and travel expectations before positioning this as the final recommendation.';
  }
  if (label.includes('duration') || label.includes('window')) {
    return 'Confirm timing and workload fit, then position the programme as worthwhile if the schedule is realistic.';
  }
  if (label.includes('senior') || label.includes('experience')) {
    return 'Confirm participant seniority so the cohort and level of stretch feel appropriate.';
  }
  return `Handle carefully when positioning this recommendation: ${cleanFitLabel(watchout)}.`;
}
